'use client'
import React from 'react'
import { useTranslations } from 'next-intl'
import { cn } from '@/lib/utils'
import { Avatar, AvatarImage } from '@/registry/default/ui/avatar'
import { text12px, text16px, text32px } from '@/app/utils'

interface FeatureProps {
  config?: any
}

export function QA({ config }: FeatureProps) {
  const t = useTranslations('home.feature')

  return (
    <div className={cn('bg-[#F1F2FE] py-8')}>
      <div
        className={
          'container flex flex-col gap-12 py-12 px-0 h-full text-foreground dark:text-background/90'
        }
      >
        <div
          className={cn(
            text32px,
            'font-bold text-[#121127] w-full text-center'
          )}
        >
          常见问题
        </div>
        <div
          className={cn(
            'items-start gap-8 md:justify-center w-full h-full md:grid lg:grid-cols-4 xl:grid-cols-4'
          )}
        >
          <div className={cn('p-4 rounded-md items-start gap-4 flex h-full')}>
            <Avatar className={cn('hidden h-7 w-7 sm:flex')}>
              <AvatarImage src={'/home/qa.svg'} alt={'Avatar'} />
            </Avatar>
            <div className={cn('flex flex-col gap-4')}>
              <div className={cn(text16px, 'text-[#121127] font-bold')}>
                我该怎么付费？
              </div>
              <div className={cn(text12px, 'text-[#1211278F]')}>
                付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以
              </div>
            </div>
          </div>
          <div className={cn('p-4 rounded-md items-start gap-4 flex h-full')}>
            <Avatar className={cn('hidden h-7 w-7 sm:flex')}>
              <AvatarImage src={'/home/qa.svg'} alt={'Avatar'} />
            </Avatar>
            <div className={cn('flex flex-col gap-4')}>
              <div className={cn(text16px, 'text-[#121127] font-bold')}>
                我该怎么付费？
              </div>
              <div className={cn(text12px, 'text-[#1211278F]')}>
                付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以
              </div>
            </div>
          </div>
          <div className={cn('p-4 rounded-md items-start gap-4 flex h-full')}>
            <Avatar className={cn('hidden h-7 w-7 sm:flex')}>
              <AvatarImage src={'/home/qa.svg'} alt={'Avatar'} />
            </Avatar>
            <div className={cn('flex flex-col gap-4')}>
              <div className={cn(text16px, 'text-[#121127] font-bold')}>
                我该怎么付费？
              </div>
              <div className={cn(text12px, 'text-[#1211278F]')}>
                付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以
              </div>
            </div>
          </div>
          <div className={cn('p-4 rounded-md items-start gap-4 flex h-full')}>
            <Avatar className={cn('hidden h-7 w-7 sm:flex')}>
              <AvatarImage src={'/home/qa.svg'} alt={'Avatar'} />
            </Avatar>
            <div className={cn('flex flex-col gap-4')}>
              <div className={cn(text16px, 'text-[#121127] font-bold')}>
                我该怎么付费？
              </div>
              <div className={cn(text12px, 'text-[#1211278F]')}>
                付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以
              </div>
            </div>
          </div>
          <div className={cn('p-4 rounded-md items-start gap-4 flex h-full')}>
            <Avatar className={cn('hidden h-7 w-7 sm:flex')}>
              <AvatarImage src={'/home/qa.svg'} alt={'Avatar'} />
            </Avatar>
            <div className={cn('flex flex-col gap-4')}>
              <div className={cn(text16px, 'text-[#121127] font-bold')}>
                我该怎么付费？
              </div>
              <div className={cn(text12px, 'text-[#1211278F]')}>
                付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以
              </div>
            </div>
          </div>
          <div className={cn('p-4 rounded-md items-start gap-4 flex h-full')}>
            <Avatar className={cn('hidden h-7 w-7 sm:flex')}>
              <AvatarImage src={'/home/qa.svg'} alt={'Avatar'} />
            </Avatar>
            <div className={cn('flex flex-col gap-4')}>
              <div className={cn(text16px, 'text-[#121127] font-bold')}>
                我该怎么付费？
              </div>
              <div className={cn(text12px, 'text-[#1211278F]')}>
                付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以
              </div>
            </div>
          </div>
          <div className={cn('p-4 rounded-md items-start gap-4 flex h-full')}>
            <Avatar className={cn('hidden h-7 w-7 sm:flex')}>
              <AvatarImage src={'/home/qa.svg'} alt={'Avatar'} />
            </Avatar>
            <div className={cn('flex flex-col gap-4')}>
              <div className={cn(text16px, 'text-[#121127] font-bold')}>
                我该怎么付费？
              </div>
              <div className={cn(text12px, 'text-[#1211278F]')}>
                付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以
              </div>
            </div>
          </div>
          <div className={cn('p-4 rounded-md items-start gap-4 flex h-full')}>
            <Avatar className={cn('hidden h-7 w-7 sm:flex')}>
              <AvatarImage src={'/home/qa.svg'} alt={'Avatar'} />
            </Avatar>
            <div className={cn('flex flex-col gap-4')}>
              <div className={cn(text16px, 'text-[#121127] font-bold')}>
                我该怎么付费？
              </div>
              <div className={cn(text12px, 'text-[#1211278F]')}>
                付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以付费方式有很多种，你可以
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
